import React, { useState, useEffect, useContext } from 'react';
import {Grid, GridColumn as Column, GridCellProps, GridToolbar, getSelectedState, GridSelectionChangeEvent, GridHeaderCellProps, GridColumn} from '@progress/kendo-react-grid';
import { Button, DropDownButton, DropDownButtonItemClickEvent } from '@progress/kendo-react-buttons';
import { Input, InputChangeEvent } from '@progress/kendo-react-inputs';
import { DatePicker, DatePickerChangeEvent } from '@progress/kendo-react-dateinputs';
import { PageContext } from './PageContext';
import { UserContext } from './UserContext';
import { CreativeChange, PubListEntry, runDate, RunDateToDelete } from '../services/interfaces';
import { getter } from '@progress/kendo-react-common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTrash, faQuestionCircle} from '@fortawesome/free-solid-svg-icons';
import { deleteRunDate, doCreativeChange, getAdRundates, getPackageData, getRMSizesRequested } from '../services/apiService';
import { faSortDown } from '@fortawesome/free-solid-svg-icons';
import { addRunDate } from '../services/apiService';
import { NewLiveRunDate } from '../services/interfaces';
import { PubList } from './FormComponents';
import { Notification } from '@progress/kendo-react-notification';
import { GridLayout, GridLayoutItem } from '@progress/kendo-react-layout';
import {DateTime} from 'luxon'
import { load, IntlProvider } from '@progress/kendo-react-intl';
import usCaGregorian from "cldr-dates-full/main/en/ca-gregorian.json";
import usDateFields from "cldr-dates-full/main/en/dateFields.json";
import gbCaGregorian from "cldr-dates-full/main/en-GB/ca-gregorian.json";
import gbDateFields from "cldr-dates-full/main/en-GB/dateFields.json";
load(usCaGregorian,usDateFields,gbCaGregorian,gbDateFields);


export function RunDates(){
    const pageContext=useContext(PageContext);
    const userContext=useContext(UserContext);
    const [showNewDate,setShowNewDate]=useState(false);
    const [showNewCreative,setShowNewCreative]=useState(false);
    const [newCreativeType, setNewCreativeType]=useState("");
    const [newDatePub, setNewDatePub]=useState<string[]>([])
    const [newDateStart, setNewDateStart]=useState<Date>();
    const [newDateEnd, setNewDateEnd]=useState<Date>();
    const [showAlert,setShowAlert] = useState(false);
    const [alertMsg, setAlertMsg]= useState("");
    const [futureRunCount, setFutureRunCount]=useState(0);
    const [newTag, setNewTag]=useState("");
    const [showNCDates, setShowNCDates]=useState(false);
    const [newNCStart,setNewNCStart]=useState<Date>();
    const [newNCEnd,setNewNCEnd]=useState<Date>();
    const [showSuccess,setShowSuccess]=useState(false);
    const [successMsg, setSuccessMsg]=useState("");
    const [showError,setShowError]=useState(false);
    const [errorMsg, setErrorMsg]=useState("");
    const [gotoAd, setGotoAd]=useState("");

    const [runDates, setRunDates]=useState<Array<runDate>>([
        {
            pubNum:0,
            pubName:"",
            tmpchar:"",
            runDate:"",
            date:0,
            rCopyUo:"",
            rCopyStatus:"",
            rCopyLines:"",
            temp1:"",
        }
    ]);


    const [selectedState, setSelectedState] = React.useState<{
            [id: string]: boolean | number[];
        }>({});

    const idGetter = getter("runDate");

    const newTagChange = (event: InputChangeEvent) => {
        setNewTag(event.value);
    }
    
    const onSelectionChange = React.useCallback(        
        (event: GridSelectionChangeEvent) => {
            console.log(event);
            const newSelectedState = getSelectedState({
                event,
                selectedState: selectedState,
                dataItemKey: "runDate"
            });
            setSelectedState(newSelectedState);
        },
        [selectedState]
    );

    const deleteThisRundate=(rundate: runDate) => {
        console.log("Delete Rundate:", rundate);
        if (pageContext?.selectedAd){
            const dateToDelete:RunDateToDelete={
                element: pageContext?.selectedAd.element,
                pubNum: rundate.pubNum,
                startDate: rundate.date.toString(),
            }
            deleteRunDate(dateToDelete).then(()=>{
                getRundates();
            });
        }
        // Add logic to handle emailing the contact
    }
    
    const contactButtons = (props: GridCellProps) => {
        return (
            <td>
                <a href="#" onClick={() => deleteThisRundate(props.dataItem)}><FontAwesomeIcon icon={faTrash}></FontAwesomeIcon></a>
            </td>
        );
    }

    const insertRunDate =()=>{
        if (dateValid()) {
            if (newDateStart){
                const newDate:NewLiveRunDate={
                    element:pageContext?.selectedAd.element ?? "",
                    pubNum: Number(newDatePub),
                    startDate:newDateStart,
                    endDate:newDateEnd ?? newDateStart
                }
                addRunDate(newDate).then(data=>{
                    console.log(data);
                    hideNotification();
                    getRundates();
                });
            };
        } else {
            // Handle error: start or end date not set
            showNotification();
        }
    }

    const dateValid =()=>{
        if (newDatePub.length>0){
            if (newDateStart){
                return true;
            }else{
                setAlertMsg("Start Date must be set");
                return false;
            }
        }else{
            setAlertMsg("Publication must be set");
            return false;
        }
    }

    const getRundates=()=>{
        const element = pageContext?.selectedAd.element;
        if (element){
            getAdRundates(element).then(data=>{
                setRunDates(data);
            });
        }
    } 

    const updateFutureRunCount=()=>{
        var count =0;
        var now = new Date();
        runDates.forEach((date: runDate) => {
            const dtStr = date.date.toString();
            var year = dtStr.substring(0,4);
            var month = dtStr.substring(4,6);
            var day = dtStr.substring(6);
            const parseDt = month + "/" + day + "/" + year;
            const rd = new Date(parseDt);
            if (rd > now) {
                count++;
            }
        });
        setFutureRunCount(count);
    }


    const EmptyCell = (props:GridHeaderCellProps) => {
        return <span />;
    };

    const newDateShow=()=>{
        setNewDatePub([]);
        setNewDateStart(undefined);
        setNewDateEnd(undefined);
        setShowNewDate(true);
    }

    const newDateHide=()=>{
        setShowNewDate(false);
    }

    const newCreativeShow=(e:DropDownButtonItemClickEvent)=>{
        console.log(e.item);
        if (Object.keys(selectedState).length > 0){
            hideError();
            switch (e.item){
                case "Assign Creative":
                    setNewCreativeType("rcDuplicate");
                    setShowNCDates(true);
                    break;
                case "Blank Ad":
                    setShowNCDates(false);
                    setNewCreativeType("rcBlankAd");
                    break;
                case "Pickup With Change":
                    setShowNCDates(false);
                    setNewCreativeType("rcPickupWC");
                    break;
            }
            setShowNewCreative(true);
        }
        else{
            setErrorMsg("You must select a run date from the list below to continue.");
            notifyError();
        }

    }

    const notifySuccess=()=>{
        setShowSuccess(true);
    }

    const hideSuccess=()=>{
        setShowSuccess(false);
    }

    const notifyError=()=>{
        setShowError(true);
    }

    const hideError=()=>{
        setShowError(false);
    }


    const newCreativeHide=()=>{
        setShowNCDates(false);
        setShowNewCreative(false);
    }

    const setCreativeStart =(date:DatePickerChangeEvent)=>{
        console.log(date);
        setNewNCStart(date.value ?? undefined);
    }

    const setCreativeEnd =(date:DatePickerChangeEvent)=>{
        console.log(date);
        setNewNCEnd(date.value ?? undefined);
    }

    const newCreativeSave=()=>{
        console.log("Save New Creative");
        var selDates: runDate[] = [];
        runDates.map(item=>{
            if (Object.keys(selectedState).includes(item.runDate)){
                selDates.push(item);
            }
        })
        if (newCreativeType=="rcDuplicate" && newNCStart) {
            let startDT: DateTime | undefined;
            let endDT: DateTime | undefined;
            if (newNCStart){
                startDT = DateTime.fromJSDate(newNCStart);
            }
            if (newNCEnd){
                endDT = DateTime.fromJSDate(newNCEnd);
            }
            if (startDT){
                var shortDate = { ...DateTime.DATE_SHORT, year: "2-digit" as const };
                var longDate = { ...DateTime.DATE_SHORT, month: "2-digit",day:"2-digit" as const }

                var newRunDate:runDate={
                    runDate:startDT.toFormat("LL/dd/yy"),
                    date:Number(startDT.toFormat("yyyyLLdd")),
                    pubNum:selDates[0].pubNum,
                    pubName:selDates[0].pubName,
                    tmpchar:selDates[0].tmpchar,
                    rCopyStatus:selDates[0].rCopyStatus,
                    rCopyLines:selDates[0].rCopyLines,
                    rCopyUo:selDates[0].rCopyUo,
                    temp1:selDates[0].temp1
                }
                if (endDT){
                    newRunDate.rCopyUo=endDT.toFormat("LL/dd/yy")
                }
                selDates=[];
                selDates.push(newRunDate);
            }
        }
        const creativeChange: CreativeChange = {
            // Add properties here that match the CreativeChange interface
            element:pageContext?.selectedAd.element||"",
            slug:pageContext?.selectedAd.slug||"",
            rcType:newCreativeType,
            tagLine:newTag,
            path:pageContext?.selectedAd.path||"",
            runDates:JSON.stringify(selDates)
        };
        console.log(creativeChange);
        doCreativeChange(creativeChange).then(data=>{
            console.log(data);
            if (data && data!==""){
                setGotoAd(typeof data === 'string' ? data : '');
                console.log("Success");
                setSuccessMsg("Creative change successfull processed.");
                notifySuccess();
                newDateHide();
            }else{
                setErrorMsg("An error occurred. Creative change was not processed.");
                notifyError();
            }
        });

    }

    const setSelectedPub=(pub:string[])=>{
        console.log(pub);
        setNewDatePub(pub);
    }

    const newDateStartSet=(date:DatePickerChangeEvent)=>{
        console.log(date.value);
        if (date.value){
            setNewDateStart(date.value);
        }
    }

    const newDateEndSet=(date:DatePickerChangeEvent)=>{
        
        if (date.value){
            setNewDateEnd(date.value);
        }
    }

    const showNotification=()=>{
        setShowAlert(true);
    }

    const hideNotification=()=>{
        setShowAlert(false);
    }

    const formatDate=(e:GridCellProps)=>{
        const date = e.dataItem.runDate.toString();
        const locale = pageContext?.glSettings.Locale||"en-US"
        const formatTime = new Date(date).toLocaleDateString(locale);        
        return (
            <td>
                {formatTime}
            </td>
        );
    }

    const DatesToolbar=()=>{        
        if(showNewDate){
            return(
                <>
                <PubList setReturnAction={setSelectedPub} value={newDatePub} type='single' archiveOnly={false} liveOnly={true} siteFilter='' className='' returnField='num' printOnly={false} onlineOnly={false} same={false}></PubList>
                <IntlProvider locale={pageContext?.glSettings.Locale||"en-US"}>
                
                <DatePicker id="startDate" onChange={newDateStartSet} min={new Date()} value={newDateStart}/>
                <DatePicker id="endDate" onChange={newDateEndSet} min={new Date()} value={newDateEnd}/>
                </IntlProvider>
                <Button title="Save" themeColor={'secondary'} type="button" onClick={insertRunDate}>Save</Button>
                <Button title="Cancel" themeColor={'secondary'} type="button" onClick={newDateHide}>Cancel</Button>
                {showAlert?<Notification type={{ style: "error", icon: true }} closable={true} onClose={hideNotification}>{alertMsg}</Notification>:null}   
                </>
            )
        }else{
            if (showNewCreative){
                return(
                    <>
                    <GridLayout rows={[{height:50}, {height:50},{height:50}]} gap={{rows:10}}>
                    {showNCDates?<>
                    <GridLayoutItem>
                    Start Date: <DatePicker title="Start Date" min={new Date()} value={newNCStart} onChange={setCreativeStart}/> 
                    &nbsp; End Date: <DatePicker title="End Date" min={new Date()} value={newNCEnd} onChange={setCreativeEnd}/>
                    </GridLayoutItem>
                    </>:null}
                    <GridLayoutItem>
                    <Input className='formField' placeholder='Enter a new tagline' value={newTag} onChange={newTagChange}></Input>
                    </GridLayoutItem>
                    <GridLayoutItem>
                        <Button title="Save" themeColor={'secondary'} type="button" onClick={newCreativeSave}>Save</Button>
                        <Button title="Add Date" themeColor={'secondary'} type="button" onClick={newCreativeHide}>Cancel</Button>
                    </GridLayoutItem>
                    </GridLayout>
                    </>
                )
            }else{
                if (pageContext?.selectedAd.elementType=="DA"){
                    //DA ADS
                    
                    return(
                        <>
                        {futureRunCount>1 && pageContext.uiFeatures.runningChange==="true"?<DropDownButton title="Creative Change" themeColor={'secondary'} items={['Pickup With Change','Blank Ad']} text="Creative Change" iconClass="fa fa-caret-down" onItemClick={newCreativeShow}/>:null}
                        <Button title="Add Date" themeColor={'secondary'} type="button" onClick={newDateShow}>Add Date</Button>
                        </>    
                    )
                }else{
                    //RM ADS
                    return(
                        <>
                        {pageContext?.uiFeatures.runningChange==="true"?<DropDownButton title="Creative Change" themeColor={'secondary'} items={['Assign Creative']} text="Creative Change" iconClass="fa fa-caret-down" onItemClick={newCreativeShow}/>:null}
                        <Button title="Add Date" themeColor={'secondary'} type="button" onClick={newDateShow}>Add Date</Button>
                        </>    
                    )
                }
            }
        }
    }

    useEffect(()=>{
        console.log("New Pub Set");
        console.log(newDatePub);
    },[newDatePub])
    useEffect(()=>{
        updateFutureRunCount();
    },[runDates])

    useEffect(()=>{
        console.log(selectedState);
    },[selectedState])

    useEffect(() => {
        getRundates();
    }, []);
    return(
        <>
        {showSuccess&& <Notification type={{style:"success", icon:true}} onClose={hideSuccess}><span>{successMsg}</span> {gotoAd!=""?<a href={`/?ad=${gotoAd}`}>Go to ad {gotoAd}</a>:null}</Notification>}
        {showError&& <Notification type={{style:"error", icon:true}} onClose={hideError}><span>{errorMsg}</span></Notification>}

        <Grid
            data={runDates.map((item) => ({ ...item, "selected": selectedState[idGetter(item)] }))}
            dataItemKey='runDate'
            //selectedField='selected'
            selectable={{enabled: true, mode:"multiple"}}
            onSelectionChange={onSelectionChange}
        >
            <GridToolbar>
                {DatesToolbar()}
            </GridToolbar>
            <Column
                columnType='checkbox'
                field="selected"
                title="&nbsp;"
                width="40px"
                cells={{headerCell:EmptyCell}}
            />
            <Column
                field='tmpChar'
                title='Site'
            />
            <Column
                field='runDate'
                title='Date'
                cells={{data:formatDate}}
            />
            <Column
                field='pubName'
                title='Publication'
            />
            <Column
                field='pubNum'
                title='Pub #'
            />
            <Column
                field='rCopyUo'
                title='End Date'
            />
            <Column
                field='rCopyStatus'
                title='Appearance'
            />
            <Column
                field='rCopyLines'
                title='Section'
            />
            <Column
                field='temp1'
                title='Size'
            />
            <Column
                title='&nbsp;'
                cells={{data:contactButtons}}
            />
        </Grid></>
    )
}



export const PackageData = () => {
        const pageContext = useContext(PageContext);
        const [data, setData] = React.useState<any[]>([]);
        const site = pageContext?.selectedAd.file1;
        const element = pageContext?.selectedAd.element;


        getRMSizesRequested(element).then(fetchedData => {
            //console.log(fetchedData);
            setData(fetchedData);
        });

        useEffect(() => {           
            getPackageData();
        }, []);

        return (
            data?.length||0>0 ? (
                <div className="mt-3">
                    <p><strong>Requested Sizes/Packages: </strong></p>
                    <Grid data={data}>
                        <GridColumn field="packageName" title="Package Name" />
                        <GridColumn field="strOut" title="Requested Size" />
                        <GridColumn field="temp1Char" title="Question Form" />
                        <GridColumn field="product" title="Product" />
                        <GridColumn field="webType" title="Web Type" />
                    </Grid>
                </div>
            ) : null
        );
    };